import axios from 'axios';
import React, { useEffect, useRef, useState, useCallback } from 'react';

// const baseURL = "http://192.168.0.11:3001";
const baseURL = "https://connect.dhamaka.app"

export default function MultiOTTPayU() {
    const hasCalled = useRef(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const paymentInitiatePayU = useCallback(async () => {
        const params = new URL(window.location.href).searchParams;
        const userId = params.get("userId") || params.get("user_id");
        const ottId = params.get("ottId") || params.get("ott_id");
        const planId = params.get("planId") || params.get("plan_id");
        const movieId = params.get("movieId") || params.get("movie_id");
        const seriesId = params.get("seriesId") || params.get("series_id");
        const isAdFreeParam = params.get("isAdFree") || params.get("is_ad_free");
        const isAdFree = isAdFreeParam === "true" || isAdFreeParam === true;
        const couponCode = params.get("couponCode") || params.get("coupon_code");

        console.log("Parsed URL Parameters:", { userId, ottId, planId, movieId, seriesId, isAdFree, couponCode });

        if (!userId || !ottId || (!planId && !movieId && !seriesId)) {
            const missing = [];
            if (!ottId) missing.push("ott_id");
            if (!userId) missing.push("user_id");
            if (!planId && !movieId && !seriesId) missing.push("plan_id / movie_id / series_id");
            const msg = `Missing required query parameter(s): ${missing.join(", ")}`;
            setError(msg);
            console.error(msg);
            return;
        }

        try {
            setLoading(true);
            setError(null);

            const payload = {
                ottId: Number(ottId),
                userId: Number(userId),
            };

            if (planId) {
                payload.planId = Number(planId);
            }
            if (movieId) {
                payload.movieId = Number(movieId);
                payload.isAdFree = isAdFree;
            }
            if (seriesId) {
                payload.seriesId = Number(seriesId);
                payload.isAdFree = isAdFree;
            }
            if (couponCode) {
                payload.couponCode = couponCode;
            }

            console.log("Payment gateway initiate payload:", payload);

            const resData = await axios.post(
                `${baseURL}/api/v1/payment/payment_gateway_initiate`,
                payload,
                {
                    headers: {
                        'accept': '*/*',
                        'Content-Type': 'application/json',
                    }
                }
            );

            console.log("Payment response:", resData.data);

            const gatewayData = resData?.data?.data;
            if (!gatewayData) {
                throw new Error("Invalid response from payment gateway initiation API.");
            }

            const form = document.createElement("form");
            form.method = "POST";
            form.action = "https://test.payu.in/_payment";
            // form.action = "https://secure.payu.in/_payment";

            const fields = {
                key: gatewayData.MERCHANT_KEY,
                txnid: gatewayData.transactionId,
                amount: gatewayData.amount,
                productinfo: gatewayData.productinfo,
                firstname: gatewayData.firstname,
                email: gatewayData.email || "harshil.icode49@gmail.com",
                phone: gatewayData.mobile,
                surl: `${baseURL}/api/v1/payment/payment_gateway_verify`,
                furl: `${baseURL}/api/v1/payment/payment_gateway_verify`,
                hash: gatewayData.hash_value,
            };

            Object.keys(fields).forEach((key) => {
                const input = document.createElement("input");
                input.type = "hidden";
                input.name = key;
                input.value = fields[key] || "";
                form.appendChild(input);
            });

            document.body.appendChild(form);
            form.submit();

        } catch (err) {
            console.error("Payment API error:", err);
            const message = err?.response?.data?.message || err.message || "Payment initiation failed.";
            setError(message);
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        if (hasCalled.current) return;
        hasCalled.current = true;

        paymentInitiatePayU();
    }, [paymentInitiatePayU]);

    return (
        <div style={styles.container}>
            <div style={styles.card}>
                {error ? (
                    <div>
                        <div style={styles.errorBadge}>✕</div>
                        <h2 style={styles.title}>Payment Failed / Error</h2>
                        <p style={styles.errorText}>{error}</p>

                        <div style={styles.btnGroup}>
                            <button onClick={paymentInitiatePayU} style={styles.primaryBtn}>
                                Retry Payment
                            </button>
                            <button
                                onClick={() => window.location.href = `multiott://payment-failed?error=${encodeURIComponent(error)}`}
                                style={styles.secondaryBtn}
                            >
                                Back to App
                            </button>
                        </div>
                    </div>
                ) : (
                    <div>
                        <div style={styles.spinner}></div>
                        <h2 style={styles.title}>
                            {loading ? "Redirecting to PayU..." : "Multi OTT PayU"}
                        </h2>
                        <p style={styles.subtitle}>
                            Please wait while we securely redirect you to the PayU payment gateway.
                        </p>

                        {!loading && (
                            <button onClick={paymentInitiatePayU} style={styles.primaryBtn}>
                                Pay Now
                            </button>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
}

const styles = {
    container: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#f4f6f9",
        padding: "20px",
        fontFamily: "'Segoe UI', Roboto, Helvetica, Arial, sans-serif",
    },
    card: {
        backgroundColor: "#ffffff",
        borderRadius: "16px",
        boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
        padding: "36px 28px",
        maxWidth: "460px",
        width: "100%",
        textAlign: "center",
    },
    title: {
        fontSize: "22px",
        fontWeight: "700",
        color: "#1e293b",
        margin: "12px 0 8px",
    },
    subtitle: {
        fontSize: "14px",
        color: "#64748b",
        marginBottom: "24px",
        lineHeight: "1.5",
    },
    spinner: {
        width: "48px",
        height: "48px",
        border: "4px solid #e2e8f0",
        borderTop: "4px solid #0d6efd",
        borderRadius: "50%",
        animation: "spin 1s linear infinite",
        margin: "16px auto 20px",
    },
    errorBadge: {
        width: "60px",
        height: "60px",
        borderRadius: "50%",
        backgroundColor: "#fee2e2",
        color: "#dc2626",
        fontSize: "28px",
        fontWeight: "bold",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        margin: "0 auto 16px",
    },
    errorText: {
        color: "#dc2626",
        fontSize: "14px",
        backgroundColor: "#fef2f2",
        padding: "12px",
        borderRadius: "8px",
        marginBottom: "20px",
    },
    primaryBtn: {
        backgroundColor: "#0d6efd",
        color: "#ffffff",
        border: "none",
        borderRadius: "8px",
        padding: "12px 24px",
        fontSize: "15px",
        fontWeight: "600",
        cursor: "pointer",
        width: "100%",
        transition: "background-color 0.2s",
    },
    secondaryBtn: {
        backgroundColor: "#f1f5f9",
        color: "#475569",
        border: "none",
        borderRadius: "8px",
        padding: "12px 24px",
        fontSize: "15px",
        fontWeight: "600",
        cursor: "pointer",
        width: "100%",
        marginTop: "10px",
    },
    btnGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "10px",
    }
};
